import logo from "./logo.svg";
import Body from "./Body";
import Home from "./Home";
import Head from "./Head";

function App() {
  return (
    <>
      <Body />
      <Head />
    </>
  );
}

export default App;
